import { SectionsState } from '../../types/sections';
import { FETCH_SECTION, FETCH_SECTION_SUCCESS } from '../actions/sections';

const defaultState = {
  active: 'home',
  isLoading: true,
} as SectionsState;

export default function sections(state = defaultState, action): SectionsState {
  switch (action.type) {
    case FETCH_SECTION:
      return {
        ...state,
        active: action.section,
        isLoading: true,
      };
    case FETCH_SECTION_SUCCESS:
      return {
        ...state,
        active: action.section || state.active,
        isLoading: false,
      };
    default:
      return state;
  }
}
